var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTagging(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 17146",
    fill: "none",
    d: "M0 0h16v16H0z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "icons Q2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 37073",
    fill: "#185edf",
    transform: "translate(.296 1.002)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21482",
    d: "M7.389 13.018 13.302 7.1V1.4h-5.7L1.685 7.314l5.7 5.7m0 1.68a.7.7 0 0 1-.49-.21L.215 7.8a.665.665 0 0 1 0-.98L7.039 0h6.964a.7.7 0 0 1 .7.7v6.964l-6.825 6.823a.7.7 0 0 1-.489.213Z"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 5399",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(8.704 2.999)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagging);
export default __webpack_public_path__ + "static/media/tagging.e18453dcc0a2b4af2b3c1858ca425dbe.svg";
export { ForwardRef as ReactComponent };